import { render } from "./AppIletisim.vue?vue&type=template&id=3ad8807c&scoped=true"
import script from "./AppIletisim.vue?vue&type=script&lang=js"
export * from "./AppIletisim.vue?vue&type=script&lang=js"

import "./AppIletisim.vue?vue&type=style&index=0&id=3ad8807c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad8807c"]])

export default __exports__